var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLtThruarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 111,
    viewBox: "0 0 162 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 72H134V99H0V72Z",
    fill: "#005DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162 85L132.75 110.981V59.0192L162 85Z",
    fill: "#005DAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 99V73H43C52.5 73 58 69.5 63 64C67 59 70 52.5 70 45V26H58L84 0L110 26H98V44C98 64 92.5166 73.9834 85 81.5C77 89.5 63 99 44 99H0Z",
    fill: "#005DAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtThruarrow);
export default __webpack_public_path__ + "static/media/LT_thruarrow.76aa8da018a91053ebc1ec162bb2e742.svg";
export { ForwardRef as ReactComponent };